import type { ReactNode } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { InlineInfoIcon } from 'components/icons';

interface CustomTooltipProps {
  title: ReactNode;
  arrow?: boolean;
}

const CustomTooltip = ({ title, arrow = false }: CustomTooltipProps) => {
  return (
    <Tooltip title={title} arrow={arrow}>
      <span
        className="tooltip-trigger"
        style={{ display: 'inline-flex', alignItems: 'center', verticalAlign: 'middle', lineHeight: 1, marginLeft: 6 }}
      >
        <InlineInfoIcon />
      </span>
    </Tooltip>
  );
};

export default CustomTooltip;
